module.exports = __webpack_public_path__ + "static/media/caretRight.b0d191b3.svg";